import React from 'react'
import { DetailCard } from '@artprov/design-system'

const feedbackStyles = {
    "Aprobado": "check",
    "En proceso": "schedule",
    "Pendiente": "pendiente",
    "Rechazado": "close",
    "Finalizado": "radio_button_checked"
}

const BodyContent = (nombre = "", status = "", fecha = null, label = null) =>
    <> {nombre}
        <div className={`flex justify-between text-sm w-full `} >
            <span>{label || "Autorizante"}</span>
            <span>{["Aprobado", "Rechazado"].includes(status) ? `${status} el ${fecha?.replaceAll("-", "/")}` : status}</span>
        </div>
    </>

export default function PanelAutorizantes({ autorizantes = [] }) {

    return (
        <div className="panel-autorizantes rounded bg-gray-300 p-4">
            {autorizantes.length > 0 ? autorizantes.map(({ nombre, cargo, estado, fecha, label = null }, i) => {
                const style = feedbackStyles[estado]

                return <DetailCard
                    key={nombre + i}
                    className={`flex-col custom-detail-card icon-${style} ${["pendiente", "radio_button_checked"].includes(style) && "title-wait"} my-1 gap-0`}
                    icon={style === "pendiente" ? "radio_button_unchecked" : style}
                    title={cargo}
                    content={BodyContent(nombre, estado, fecha, label)}
                />
            }) : <DetailCard className="flex-col icon-reject" icon='error' title='Error' content='No se pudieron obtener los datos de autorizantes' />}
        </div >
    )
}